import dayjs from 'dayjs';

import type { ChangeOrderStatus, JobChangeOrder } from '../../types';
import type { BadgeTone } from '@web/ui';

export function getChangeOrderStatusLabel(status: ChangeOrderStatus | string) {
  if (status === 'draft') {
    return 'Draft';
  }

  if (status === 'applied') {
    return 'Applied';
  }

  return `${status.charAt(0).toUpperCase()}${status.slice(1)}`;
}

export function getChangeOrderStatusTone(
  status: ChangeOrderStatus | string,
): BadgeTone {
  if (status === 'applied') {
    return 'success';
  }

  if (status === 'draft') {
    return 'warning';
  }

  return 'default';
}

export function formatImpactHours(value: number | null | undefined) {
  const hours = Number(value ?? 0);
  const prefix = hours > 0 ? '+' : '';
  return `${prefix}${Number.isInteger(hours) ? hours : hours.toFixed(1)} hrs`;
}

export function formatChangeOrderDate(changeOrder: JobChangeOrder) {
  const date =
    changeOrder.applied_at ?? changeOrder.updated_at ?? changeOrder.created_at;

  if (!date) {
    return '-';
  }

  return dayjs(date).format('MMM D, YYYY');
}

export function getDefaultChangeOrderName(existingCount: number) {
  return `CO-${String(existingCount + 1).padStart(3, '0')}`;
}
